import React from "react";
import { t } from "locales";
import FullWidthPageBackground from "components/FullWidthPageBackground";
import "./style.scss";

export default function BlockMeasuringSuccess() {
  return (
    <div className="block-measuring-success text-center py-6">
      <FullWidthPageBackground className="block-measuring-success__background" />
      <div className="block-measuring-success__content subtitle-1 fw-bold text-center">
        {t(
          "We measure success by outcomes, not activity. Students secure offers. Universities see ROI in employability, satisfaction, and rankings."
        )}
      </div>
    </div>
  );
}
